module.exports = __webpack_public_path__ + "img/Weapon_209.05b5461b.png";